<div class="ig-close-button close-btn-bg" (click)="close()" role="button">
    BACK TO ALL EVENTS
</div>

<div class="confirm-modal ig-modal event-details-modal-new">

    <div class="flex">
        <div des #descriptionEle class="panel relative description-sec" [class.small-description-sec]="isSmallView">
            <ng-container *ngIf="!isSmallView">
                <div class="flex space-between">
                    <p title #titleTitle>{{event?.title || event?.name}}</p>

                    <div link>
                        <div class="flex">
                            <ig-add-to-trip-menu *ngIf="isTripPlannerOn" [hubName]="hubName" [item]="event"
                                [inTripText]="'In My Trip'" [addToTripText]="'+ My Trip'">
                            </ig-add-to-trip-menu>
                            <ig-social-share *ngIf="event" [item]="event" appearance="rounded" [showTip]="false"
                                (onShareEmail)="addShareEmail()" (onShareToFB)="addShareFB()"
                                (onShareToTweet)="addShareTweet()"></ig-social-share>
                            <mat-icon (click)="showEventLink()" matTooltip="Get event link">link</mat-icon>
                        </div>
                    </div>
                </div>

                <div class="p-r-3 m-t-3 descrip" about [class.no-content]="!event?.description"
                    [innerHTML]="event?.description||'(No description)'">
                </div>
            </ng-container>

            <ng-container *ngIf="isSmallView">
                <div class="flex space-between" style="height: 39%">
                    <div class="relative"
                        [ngStyle]="{'width':settingsCommand.calendarStyle.event==='square'?'71%':'66%'}">
                        <p title #eventTitle>{{event?.title || event?.name}}</p>
                        <div style="position: relative;padding-bottom: 24px">
                            <div #description class="p-r-3 descrip" about [class.no-content]="!event?.description"
                                [class.three-lines]="isMultiLinesTitle"
                                [innerHTML]="displayDescription||'(No description)'" style="overflow: auto;">
                            </div>
                            <div *ngIf="needReadMore" class="read-more-des" (click)="showDescription()">read more</div>
                        </div>
                        <div class="small-time-section">
                            <p name>Dates & Times</p>
                            <div class="relative">
                                <div *ngIf="isNeedScroll&&!isAtStart" class="scroll-wrap scroll-left"
                                    (mousedown)="scrollLeft()" (mouseup)="clearTimeMousemoveInterval()">
                                    <div></div>
                                </div>
                                <div
                                    [ngStyle]="{'paddingLeft':isAtStart?0:'30px','width':isAtStart?'calc(100% - 40px)':'calc(100% - 68px)'}">
                                    <div #timewrap class="small-time-wrap">
                                        <div *ngFor="let time of event?.eventTimes">
                                            <!--                                            {{time.startTimeFormatted}}-->
                                            <div>
                                                <p style="font-weight: bold">{{time['noTimeFormatted']}}</p>
                                                <p style="font-size: 13px">{{time['timeFormatted']}}</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div *ngIf="isNeedScroll&&!isAtEnd" matTooltip="Hold down the mouse to scroll"
                                    class="scroll-wrap scroll-right" (mousedown)="scrollRight()"
                                    (mouseup)="clearTimeMousemoveInterval()">
                                    <div></div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div [ngStyle]="{'width':settingsCommand.calendarStyle.event==='square'?'30%':'33%'}">
                        <div image class="m-b-1 text-center"
                            [class.square-img]="settingsCommand.calendarStyle.event==='square'">
                            <ig-image #imgComp [imageUrl]="event?.cover?.source"
                                [alt]="event?.title||event?.name"></ig-image>
                        </div>
                        <div class="flex" [style.justifyContent]="isTripPlannerOn?'space-between':'end'">
                            <ig-add-to-trip-menu *ngIf="isTripPlannerOn" [hubName]="hubName" [item]="event"
                                [inTripText]="'In My Trip'" [addToTripText]="'+ My Trip'">
                            </ig-add-to-trip-menu>
                            <div link class="flex">
                                <ig-social-share *ngIf="event" [item]="event" appearance="rounded" [showTip]="false"
                                    (onShareEmail)="addShareEmail()" (onShareToFB)="addShareFB()"
                                    (onShareToTweet)="addShareTweet()"></ig-social-share>
                                <mat-icon (click)="showEventLink()" matTooltip="Get event link">link</mat-icon>
                            </div>
                        </div>
                    </div>
                </div>
            </ng-container>

            <section class="flex e-info">
                <div class="e-title">
                    <p name>Information {{(toggles.eventTicketUrl && !event.isHideTicketUrl) ? 'and Tickets' : ''}}</p>

                    <div *ngIf="toggles.eventTicketUrl && !event.isHideTicketUrl">
                        <div *ngIf="normalTicketUri" class="flex space-between">
                            <div class="e-venue">{{processedTicketUri}}</div>
                            <ig-button class="ticket-btn" size="md" (trigger)="openTicketUrl(event?.ticketUri)">Tickets
                            </ig-button>
                        </div>
                        <div *ngIf="!normalTicketUri&&event?.ticketInfo?.length">
                            <div *ngFor="let e of event?.ticketInfo" class="flex space-between m-t-3">
                                <div style="line-height: 32px" class="e-venue">{{e.source.replace('www.', '')}}</div>
                                <ig-button class="ticket-btn" size="md" (trigger)="openTicketUrl(e.link)">Tickets
                                </ig-button>
                            </div>
                        </div>
                    </div>

                    <div class="flex space-between m-t-3">
                        <div style="line-height: 32px" class="e-venue">{{event?.owner?.name}}</div>
                        <ig-button size="md" color="cancel" (trigger)="visitWebsite()">More info</ig-button>
                    </div>
                </div>
                <div class="e-title">
                    <p name>Venue & Location</p>

                    <a *ngIf="event?.hostLink&&venueName" class="e-venue" [href]="getLink(event?.hostLink)"
                        target="_blank" [matTooltip]="venueName">{{venueName}}</a>
                    <p *ngIf="!event?.hostLink&&venueName" class="e-venue" [matTooltip]="venueName">{{venueName}}</p>
                    <div *ngIf="event?.venueInfo?.rating" class="flex m-t-1">
                        <p>{{event?.venueInfo?.rating}}</p>
                        <ig-stars [rating]="event?.venueInfo?.rating"></ig-stars>
                    </div>
                    <div *ngIf="event?.venueInfo?.reviews">{{event?.venueInfo?.reviews}} reviews</div>

                    <div class="relative m-t-2">
                        <div *ngIf="event?.isOnlineEvent" class="online-event-tip">
                            <div class="vertical-middle">This event is virtual and does not include a physical address
                            </div>
                        </div>
                        <agm-map [class.short-map]="event?.venueInfo?.rating" [styles]="hideIconMapStyler"
                            [latitude]="event?.address?.lat||USCenterLat" [longitude]="event?.address?.lng||USCenterLng"
                            [zoom]="event?.isOnlineEvent?3:mapZoom">
                            <agm-marker *ngIf="event?.address?.lat&&event?.address?.lng"
                                [latitude]="event?.address?.lat" [longitude]="event?.address?.lng">
                            </agm-marker>
                        </agm-map>

                    </div>

                    <div *ngIf="event?.address?.address" class="flex space-between m-t-2">
                        <p class="e-address" [matTooltip]="event?.address?.address">{{event?.address?.address}}</p>
                        <ig-button size="md" class="deep-orange-btn" (trigger)="getDirection()">Get directions
                        </ig-button>
                    </div>
                </div>
            </section>
        </div>

        <div *ngIf="!isSmallView" class="e-dates">
            <div image class="panel">
                <ig-image #imgComp [imageUrl]="event?.cover?.source" [alt]="event?.title||event?.name"></ig-image>

                <p name>Dates & Times</p>
            </div>

            <div class="edm-time-col">
                <div *ngFor="let time of event?.eventTimes" class="panel">
                    <div [class.flex]="time.start">
                        <div style="font-size: 16px;font-weight: bold">
                            <div>{{time.noTimeFormatted}}</div>
                        </div>
                    </div>
                    <div class="m-t-2">{{time.timeFormatted}}</div>
                </div>
            </div>
        </div>

        <div #mapColumn class="upcoming-events-wrap panel relative" [class.small-upcoming-wrap]="isSmallView">
            <ig-upcoming-events [currentEvent]="event" (onMoreClick)="close()"
                (onUpcomingEventClick)="onUpcomingEventClick()"></ig-upcoming-events>
        </div>
    </div>

</div>


<!--<agm-map [class.short-map]="event?.venueInfo?.rating" [styles]="hideIconMapStyler"-->
<!--         [latitude]="event?.address?.lat||USCenterLat"-->
<!--         [longitude]="event?.address?.lng||USCenterLng" [zoom]="event?.isOnlineEvent?3:mapZoom">-->
<!--    <agm-marker *ngIf="event?.address?.lat&&event?.address?.lng"-->
<!--                [latitude]="event?.address?.lat"-->
<!--                [longitude]="event?.address?.lng">-->
<!--    </agm-marker>-->
<!--</agm-map>-->


// WEBPACK FOOTER //
// D:/Work/Development/vsts_build/_work/2/s/web/src/components/visitor/event.details.modal/event.details.modal.component.html